import { useTranslation } from "react-i18next";
import { ApiFailure } from "../../restClient";
import "../public-page.css";

interface WithdrawalFailureNoticeProps {
  failure: ApiFailure | null;
  /** The address the withdrawal can be sent to instead. */
  contactEmail: string;
}

/**
 * The failure banner of both withdrawal steps. Every reason names the e-mail
 * route, so the right of withdrawal never depends on our server being up.
 */
function WithdrawalFailureNotice({
  failure,
  contactEmail,
}: WithdrawalFailureNoticeProps) {
  const { t } = useTranslation();

  if (!failure) {
    return null;
  }

  const problem = failure.body && failure.body.problem;
  const general = t(`withdrawal.failure.${failure.reason}`);

  return (
    <div className="pub-notice pub-notice-error" role="alert">
      <p>
        {problem
          ? t(`withdrawal.problem.${problem}`, { defaultValue: general })
          : general}
      </p>
      <p>
        {t("withdrawal.failure.fallback")}{" "}
        <a href={`mailto:${contactEmail}`} className="pub-link">
          {contactEmail}
        </a>
      </p>
    </div>
  );
}

export default WithdrawalFailureNotice;
